import { makeStyles } from '@material-ui/core';

const useLoginStyles = makeStyles((theme) => {
  const mobileBreakpoint = theme.breakpoints.down('sm');

  return ({
    subtitle: {
      fontFamily: 'var(--font-family-bold)',
      marginBottom: '0.5rem',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 500
    },
    btn_primary: {
      color: 'var(--white)',
      backgroundColor: 'var(--teal-blue)',
      '&:hover': {
        color: 'var(--white)',
        backgroundColor: 'var(--teal-blue)',
      }
    },
    subtitleLogout: {
      fontSize: '24px',
      lineHeight: '34px',
      marginBottom: '1rem',
      maxWidth: '32rem',
      [mobileBreakpoint]: {
        fontSize: 'var(--public-wrapper-default-text-size-mobile)'
      }
    },
    input: {
      backgroundColor: 'var(--white)'
    },
    inputNew: {
      background: 'var(--white) !important',
      border: '1px solid #DCDCDC',
      boxSizing: 'border-box',
    },
    fields: {
      width: '100%',
      [mobileBreakpoint]: {
        width: '100%',
      }
    },
    inputContainer: {
      width: '100%'
    },
    secondaryContent: {
      fontFamily: 'var(--font-family-base)',
      fontSize: '24px',
      lineHeight: '34px',
      '&.logout': {
        fontFamily: 'var(--font-family-bold)',
        fontSize: 'var(--public-wrapper-default-text-size-mobile)',
        paddingTop: 0
      },
      fontWeight: 500
    },
    sorryPageSecondaryContent: {
      marginBottom: '-2rem',
      marginTop: '-1.5rem'
    },
    secondaryTitle: {
      fontFamily: 'var(--font-family-bold)',
      fontSize: 'var(--logPage-header-text-size)',
      paddingTop: '0px',
      marginBottom: '2rem',
      fontWeight: 500
    },
    reAccess: {
      fontSize: 'var(--default-text-bold-size)',
      maxWidth: '32rem'
    },
    newLine: {
      whiteSpace: 'pre-line',
      fontSize: '16px'
    },
    accessYourAppTitle: {
      fontFamily: 'var(--font-family-bold)',
      paddingTop: '1rem',
      whiteSpace: 'pre-line',
      fontSize: '16px'
    },
    accessYourApp: {
      paddingTop: '1rem',
      paddingBottom: '1rem',
      whiteSpace: 'pre-line',
      fontSize: '16px'
    },
    expiredLinkMsg: {
      marginTop: '2rem'
    },
    resendEmailGuide: {
      marginBottom: 0,
      paddingLeft: '1rem'
    },
    noListMargin: {
      marginBottom: 0,
    },
    emailNotFoundSection: {
      marginTop: '85px',
      padding: '10px',
      background: 'var(--alice-blue)',
      display: 'flex',
    },
    emailNotFoundErrorIcon: {
      color: 'var(--fire-brick-red)',
    },
    emailNotFoundMessage: {
      fontWeight: 450,
      paddingLeft: '2px'
    }
  });
});

export default useLoginStyles;
